var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gotedo-loading-spinner d-flex mx-auto my-auto"},[_c('div',{staticClass:"spinner-container"},[_c('div'),_c('div'),_c('div',[_c('div')]),_c('div',[_c('div')])])])
}]

export { render, staticRenderFns }